import script from "./MapFlagsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MapFlagsView.vue?vue&type=script&setup=true&lang=js"

import "./MapFlagsView.vue?vue&type=style&index=0&id=800067c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-800067c4"]])

export default __exports__